module.exports = [{
      plugin: require('../.yarn/cache/gatsby-plugin-anchor-links-npm-1.2.1-7db63a8548-fa57ad4530.zip/node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../.yarn/__virtual__/gatsby-plugin-manifest-virtual-91c6d9a017/0/cache/gatsby-plugin-manifest-npm-5.16.0-ec44e0714a-9f760633b0.zip/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/assets/icon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c2281aca51005828cad741d67c5b3043"},
    },{
      plugin: require('../.yarn/unplugged/gatsby-virtual-a42c84fb27/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
